const { universalApi, userApi, newUniversalApi } = require("../api/api");
const { simpleGetter } = require("./common");

const createBoard = async (name, bg, id) => {
  const data = { success: false };
  let response;
  if (id) {
    const updateRequestBody = {
      model: "Board",
      body: {
        filters: {
          id,
        },
        update: {
          name,
          bg,
        },
      },
    };
    response = await simpleGetter(universalApi.update, updateRequestBody);
  } else {
    const createRequestBody = {
      model: "Board",
      body: {
        create: {
          name,
          bg,
        },
      },
    };
    response = await simpleGetter(newUniversalApi.create, createRequestBody);
  }
  if (response.success) {
    data.id = id || response.item?.id;
    data.success = true;
  }
  return data;
};

const createBoardTask = async (board_id, title, description) => {
  const data = { success: false };
  const requestBody = {
    model: "BoardTask",
    body: {
      create: {
        board_id,
        title,
        description,
        status: "В ожидании",
      },
    },
  };
  const response = await simpleGetter(newUniversalApi.create, requestBody);
  if ("item" in response) {
    data.id = response.item.id;
    data.success = true;
  }
  return data;
};

const updateBoardTask = async (filters, update) => {
  const data = { success: false };
  const requestBody = {
    model: "BoardTask",
    body: {
      filters,
      update,
    },
  };
  const response = await simpleGetter(universalApi.update, requestBody);
  if (response.success) {
    data.success = true;
  }
  return data;
};

export const boardActions = {
  createBoard,
  createBoardTask,
  updateBoardTask,
};
